//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets a PatientList configuration by id.
 * @param id Id of PatientList configuration.
 */
export function getPatientListConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.PatientListConfigurationDto> {
    let url_ = getBaseUrl() + "/api/patient-list-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientListConfiguration,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPatientListConfiguration?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientListConfiguration(_response);
    });
}

function processGetPatientListConfiguration(response: AxiosResponse): Promise<Types.PatientListConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPatientListConfigurationDto(resultData200);
        return Promise.resolve<Types.PatientListConfigurationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListConfigurationDto>(null as any);
}

export function editPatientListConfiguration(id: number, updateDto: Types.UpdatePatientListConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<Types.PatientListConfigurationDto> {
    let url_ = getBaseUrl() + "/api/patient-list-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdatePatientListConfigurationDto(updateDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditPatientListConfiguration,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditPatientListConfiguration?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditPatientListConfiguration(_response);
    });
}

function processEditPatientListConfiguration(response: AxiosResponse): Promise<Types.PatientListConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPatientListConfigurationDto(resultData200);
        return Promise.resolve<Types.PatientListConfigurationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListConfigurationDto>(null as any);
}

export function removePatientListConfiguration(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patient-list-configuration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemovePatientListConfiguration,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemovePatientListConfiguration?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemovePatientListConfiguration(_response);
    });
}

function processRemovePatientListConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function getPatientListConfigurations(config?: AxiosRequestConfig | undefined): Promise<Types.PatientListConfigurationListDto[]> {
    let url_ = getBaseUrl() + "/api/patient-list-configuration";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientListConfigurations,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPatientListConfigurations?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientListConfigurations(_response);
    });
}

function processGetPatientListConfigurations(response: AxiosResponse): Promise<Types.PatientListConfigurationListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initPatientListConfigurationListDto(item)
              );
            }
        return Promise.resolve<Types.PatientListConfigurationListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListConfigurationListDto[]>(null as any);
}

export function createPatientListConfiguration(createDto: Types.CreatePatientListConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<Types.PatientListConfigurationDto> {
    let url_ = getBaseUrl() + "/api/patient-list-configuration";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreatePatientListConfigurationDto(createDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreatePatientListConfiguration,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreatePatientListConfiguration?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreatePatientListConfiguration(_response);
    });
}

function processCreatePatientListConfiguration(response: AxiosResponse): Promise<Types.PatientListConfigurationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPatientListConfigurationDto(resultData200);
        return Promise.resolve<Types.PatientListConfigurationDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initPatientListConfigurationDto(resultData201);
        return Promise.resolve<Types.PatientListConfigurationDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListConfigurationDto>(null as any);
}

export function pinPatientListConfiguration(id: number, dto: Types.PinPatientListConfigurationDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patient-list-configuration/pin/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePinPatientListConfigurationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPinPatientListConfiguration,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPinPatientListConfiguration?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPinPatientListConfiguration(_response);
    });
}

function processPinPatientListConfiguration(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetPatientListConfiguration: Partial<AxiosRequestConfig> | null;
export function getGetPatientListConfigurationRequestConfig() {
  return _requestConfigGetPatientListConfiguration;
}
export function setGetPatientListConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientListConfiguration = value;
}
export function patchGetPatientListConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientListConfiguration = patch(_requestConfigGetPatientListConfiguration ?? {});
}

let _requestConfigEditPatientListConfiguration: Partial<AxiosRequestConfig> | null;
export function getEditPatientListConfigurationRequestConfig() {
  return _requestConfigEditPatientListConfiguration;
}
export function setEditPatientListConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditPatientListConfiguration = value;
}
export function patchEditPatientListConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditPatientListConfiguration = patch(_requestConfigEditPatientListConfiguration ?? {});
}

let _requestConfigRemovePatientListConfiguration: Partial<AxiosRequestConfig> | null;
export function getRemovePatientListConfigurationRequestConfig() {
  return _requestConfigRemovePatientListConfiguration;
}
export function setRemovePatientListConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemovePatientListConfiguration = value;
}
export function patchRemovePatientListConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemovePatientListConfiguration = patch(_requestConfigRemovePatientListConfiguration ?? {});
}

let _requestConfigGetPatientListConfigurations: Partial<AxiosRequestConfig> | null;
export function getGetPatientListConfigurationsRequestConfig() {
  return _requestConfigGetPatientListConfigurations;
}
export function setGetPatientListConfigurationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientListConfigurations = value;
}
export function patchGetPatientListConfigurationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientListConfigurations = patch(_requestConfigGetPatientListConfigurations ?? {});
}

let _requestConfigCreatePatientListConfiguration: Partial<AxiosRequestConfig> | null;
export function getCreatePatientListConfigurationRequestConfig() {
  return _requestConfigCreatePatientListConfiguration;
}
export function setCreatePatientListConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreatePatientListConfiguration = value;
}
export function patchCreatePatientListConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreatePatientListConfiguration = patch(_requestConfigCreatePatientListConfiguration ?? {});
}

let _requestConfigPinPatientListConfiguration: Partial<AxiosRequestConfig> | null;
export function getPinPatientListConfigurationRequestConfig() {
  return _requestConfigPinPatientListConfiguration;
}
export function setPinPatientListConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPinPatientListConfiguration = value;
}
export function patchPinPatientListConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPinPatientListConfiguration = patch(_requestConfigPinPatientListConfiguration ?? {});
}